<div class="controls-container">
    <div class="controls-header">Charts</div>
    <div class="layout-cards">
        <pm-card style="padding: 5px;">
            <div card-body style="width: 200px;">
                <div class="chart-title">Area Chart</div>
                <pm-area-chart style="display: flex; justify-content: center; padding-top: 10px; padding-bottom: 20px;"></pm-area-chart>
                <div class="chart-footer">Area Chart footer</div>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="width: 200px;">
                <div class="chart-title">Bar Chart</div>
                <pm-bar-chart style="display: flex; justify-content: center; padding-top: 10px; padding-bottom: 20px;"></pm-bar-chart>
                <div class="chart-footer">Bar Chart footer</div>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">            
            <div card-body style="width: 200px;">
                <div class="chart-title">Column Chart</div>
                <pm-column-chart style="padding: 10px 20px; display: flex;"></pm-column-chart>
                <div class="chart-footer">Column Chart footer</div>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">            
            <div card-body style="width: 200px;">
                <div class="chart-title">Combo Chart</div>
                <pm-combo-chart style="padding: 10px 20px; display: flex;"></pm-combo-chart>
                <div class="chart-footer">Combo Chart footer</div>
            </div>
        </pm-card>        
        <pm-card style="padding: 5px;">            
            <div card-body style="width: 200px;">
                <div class="chart-title">Donut Chart</div>
                <pm-donut-chart style="padding: 10px 20px; display: flex; height: 120px;"></pm-donut-chart>
                <div class="chart-footer">Donut Chart footer</div>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="width: 200px; display: flex; flex-direction: column;">
                <div class="chart-title">Line Bar Chart</div>
                <pm-line-bar-chart></pm-line-bar-chart>
                <div class="chart-footer">Line Bar Chart footer</div>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="width: 200px; display: flex; flex-direction: column;">
                <div class="chart-title">Line Chart</div>
                <pm-line-chart style="height: 130px;"></pm-line-chart>
                <div class="chart-footer">Line Chart footer</div>
            </div>
        </pm-card>
        <pm-card style="padding: 5px;">
            <div card-body style="width: 200px; display: flex; flex-direction: column;">
                <div class="chart-title">Pie Chart</div>
                <pm-pie-chart style="height: 170px;"></pm-pie-chart>
                <div class="chart-footer">Pie Chart footer</div>
            </div>
        </pm-card>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/charts/charts.html